/* eslint-disable camelcase */
import type { AppState } from "..";

export type AddressStateStore = {
	id: number;
	name : string;
	code: string;
	type: string;
	country_name: string;
	country_code: string;
}

export type AddressCountryStore = {
	id: number;
	name: string;
	code: string;
}

const initialAddressState: AddressStateStore = {
	id: 0,
	name: "",
	code: "",
	type: "",
	country_name: "",
	country_code: ""
};

const SelectAddressStateById = (addressStateId: number) =>
	(state: AppState) => state.entity.addressStates[addressStateId] ?? null;

export { initialAddressState, SelectAddressStateById };
